import bottle from './bottle.png'
import minus from './minus.svg'
import addWaterPlus from './addWaterPlus.svg'
import addButtonplus from './addButtonplus.svg'
import close from './close.svg'
import chevron from './chevron-down.svg'
import glass from './glass.svg'
import change from './change.svg'
import trash from './trash.svg'
import upload from './upload.svg'
import Vector from './Vector.svg'
import UserPhoto from './UserPhoto.svg'
import VectorToLeft from './VectorToLeft.svg'
import VectorToRight from './VectorToRight.svg'


export default {bottle,minus,addWaterPlus,addButtonplus,close,chevron,glass,change,trash,upload,Vector,UserPhoto,VectorToLeft,VectorToRight}
